import 'app/agriculture/routes/BackOffice/BackOfficeTopBar.scss';
import { FaarmLogo } from 'app/agriculture/FarmMain/TopBar/components/FaarmLogo/FaarmLogo';
import { ProfileWidget } from 'app/agriculture/routes/BackOffice/ProfileWidget/ProfileWidget';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { BackOfficeNav } from 'app/agriculture/routes/BackOffice/BackOfficeNav';

export function BackOfficeTopBar() {
    return (
        <div className="BackOfficeTopBar">
            <div className="BackOfficeTopBar__logo-container">
                <FaarmLogo className="BackOfficeTopBar__logo" />
            </div>
            <div className="BackOfficeTopBar__content">
                <BackOfficeNav />
            </div>
            <div className="BackOfficeTopBar__end">
                <SuspenseWrapper>
                    <ProfileWidget />
                </SuspenseWrapper>
            </div>
        </div>
    );
}
